import { shallowRef, watch } from "vue";

export function useInsightFeedSlots<T>(items: () => T[], id: (item: T) => string) {
    const slots = shallowRef<{ key: number; item: T | null }[]>([]);
    let nextKey = 0;
    watch(
        items,
        (current) => {
            const byId = new Map(current.map((item) => [id(item), item]));
            const previousIds = new Set(slots.value.flatMap((slot) => (slot.item ? [id(slot.item)] : [])));
            const replacements = current.filter((item) => !previousIds.has(id(item)));
            const next = slots.value.map((slot) => ({
                key: slot.key,
                item: (slot.item ? byId.get(id(slot.item)) : undefined) ?? replacements.shift() ?? null,
            }));
            slots.value = [...next, ...replacements.map((item) => ({ key: nextKey++, item }))];
        },
        { immediate: true },
    );
    function finishLeave(key: number) {
        slots.value = slots.value.filter((slot) => slot.key !== key || slot.item !== null);
    }
    return { slots, finishLeave };
}
